"use client"

import { useLayoutEffect } from 'react'

// Rozwija grupy od 1024 px, gdy DOM wyrenderował React, a skrypt z HTML się nie wykonał
// (nawigacja po stronie klienta, render od nowa po błędzie hydratacji).
export default function OpenGroups ({ id }) {
    useLayoutEffect(() => {
        const m = matchMedia('(min-width:1024px)')
        const open = () => { if (m.matches) document.querySelectorAll(`#${id} details`).forEach((d) => { d.open = true }) }
        open()
        m.addEventListener('change', open)
        return () => m.removeEventListener('change', open)
    }, [id])

    return null
}
